var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
import { informationCircle, registerIcon } from '@ingka/icon-store';
import { Icon as SkapaIcon } from '@ingka/icon-webc/passive.js';
import { InlineMessage as SkapaInlineMessage } from '@ingka/inline-message-webc/passive.js';
import SaveDesignToProfileCardStyle from './SaveDesignToProfileCardStyle.js';
export default class SaveDesignToProfileCard extends KompisElement {
    constructor() {
        super(...arguments);
        // Localized information. Deprecated - use "translations" instead.
        this.localizedInformation = null;
        // The translations retrieved from translations service.
        this.translations = null;
        // Whether the user is logged in to IKEA or not.
        this.loggedIn = false;
        // The url for the screenshot.
        this.screenshotUrl = null;
        // The alt text for the screenshot. If not set, a default alt text will be used.
        this.screenshotAlt = null;
        // The name of the product, e.g. PLATSA.
        this.productName = null;
        // Description of the product, e.g. "Wardrobe, 200x300x55 cm".
        this.productDescription = null;
    }
    async connectedCallback() {
        registerIcon(informationCircle);
        this.customElements.define('skapa-inline-message', SkapaInlineMessage);
        this.customElements.define('skapa-icon', SkapaIcon);
        super.connectedCallback();
    }
    render() {
        // We want translations to be required, but since both props to provide translations are optional, this check is needed until localizedInformation is removed.
        if (!this.hasTranslations()) {
            // We can't throw an error because on the first render no props are set.
            return null;
        }
        return html `
			<style>
				${SaveDesignToProfileCardStyle.getStyle({
            theme: this.theme
        })}
			</style>
			<h2 class="heading ${Text.classnames({ heading: { m: true } })}">
				${this.getTranslations().saveDesignToProfileSaveDesignHeader}
			</h2>

			${this.loggedIn ? this.getDesignToSave() : this.getLogInInlineMessage()}
		`;
    }
    hasTranslations() {
        return !!this.translations || !!this.localizedInformation?.translations;
    }
    getTranslations() {
        const translations = this.translations
            ? this.translations
            : this.localizedInformation?.translations;
        return translations;
    }
    getDesignToSave() {
        const altText = this.screenshotAlt ?? this.getTranslations().summaryPageScreenshotAltText;
        const image = this.screenshotUrl
            ? html `<img src="${this.screenshotUrl}" alt="${altText}" />`
            : null;
        return html `
			<div class="designWrapper">
				<h3 class="productName ${Text.classnames({ heading: { xs: true } })}">
					${this.productName}
				</h3>
				${image}
				<p class="productDescription ${Text.classnames({ body: { m: true } })}">
					${this.productDescription}
				</p>
			</div>
		`;
    }
    getLogInInlineMessage() {
        return html `<skapa-inline-message subtle>
			<skapa-icon slot="message-icon" icon="information-circle"></skapa-icon>
			<span slot="body">${this.getTranslations().saveDesignToProfileLogInMessage}</span>
		</skapa-inline-message>`;
    }
}
__decorate([
    property({ type: Object, required: true })
], SaveDesignToProfileCard.prototype, "theme", void 0);
__decorate([
    property({ type: Object })
], SaveDesignToProfileCard.prototype, "localizedInformation", void 0);
__decorate([
    property({ type: Object })
], SaveDesignToProfileCard.prototype, "translations", void 0);
__decorate([
    property({ type: Boolean })
], SaveDesignToProfileCard.prototype, "loggedIn", void 0);
__decorate([
    property({ type: String })
], SaveDesignToProfileCard.prototype, "screenshotUrl", void 0);
__decorate([
    property({ type: String })
], SaveDesignToProfileCard.prototype, "screenshotAlt", void 0);
__decorate([
    property({ type: String })
], SaveDesignToProfileCard.prototype, "productName", void 0);
__decorate([
    property({ type: String })
], SaveDesignToProfileCard.prototype, "productDescription", void 0);
//# sourceMappingURL=SaveDesignToProfileCard.js.map